import React from 'react'
import './Intro.css'
const Intro = () => {
    return (
        <div>
               <div class="about">
            <div class="container">
                <h2 class="h1 text-center">C introduction</h2>
                <p class="responsive-paragraph">
                <b>C</b> is now considered as a Low-programming language.It was inittially developed by <b>Dennis
Ritchie</b> in the year 1972.It is a strctured programming language that is <b>machine-independent </b>
and extensively to write various <b>application,OS like Windows,and many other complex progrms </b>
like <b>Oracle database,Git,Python interpreter and more.</b><br/>
It is said that C is a <b>god's programming language</b>.One can say, C is a base for the programming<br/>
<h2><strong>Uses</strong></h2>
Langauges such as <b>C++/Java </b>are developed from <b>'C'</b>.These languages used in various technologies 
Thus,<b>'C'</b> forms a base for many other languages that area currently in use.
<br/>
<h2><strong>Why Learn C language?</strong></h2><br/>
'C' is base language for many programming languages.So, learning <b>'C'</b> as the main language will
play an important role while studying other programming languages.<b>'C'</b> can be used widely in variouu
application.It is a simple language and provises <b>faster execution</b>.There are many jobs available for
a <b>'C'</b> can be used widely in various applications.It is a simple language and provides faster 
execution.It structure makes it easy for testing,maintaining and debugging process.

For <b>'C'</b> developers it is a boon that industry always need them.And median salary of C developer
is Rs 6 lacs per annum

<h2><strong>Limitation of C</strong></h2>
C is a very vast language but it doesn't support OOPs(Inheritance, Polymorphism, Encapsulation, Abstraction, Data Hiding).<br/>
In the C programming language, the errors or the bugs aren’t detected after each line of code. Instead, the compiler shows all the errors after writing the program. It makes the checking of code very complex in large programs.
C does not implement the concept of namespaces.Without namespaces, we cannot declare two variables of the same name.
Exception Handling is one of the most important features of programming languages. While compiling the code, various anomalies and bugs can occur
C does not have any constructor or destructor.
C is a small and core machine language that has minimum data hiding and exclusive visibility that affects the security of this language.
                </p>
            </div>
        </div>
        </div>
    )
}

export default Intro
